import React from "react";
import "../App.css";
import { Button } from "./Button";
import "./HeroSection.css";

function HeroSection() {
  return (
    <div className="hero-container">
      {/* <video src="/videos/video-3.mp4" autoPlay loop muted /> */}
      <h1>BIENVENIDOS</h1>
      <p>Villas los Altos de Boquete</p>
      <div className="hero-btns">
        <Button
          className="btns"
          buttonStyle="btn--outline"
          buttonSize="btn--large"
          linkWeb="/preguntas"
        >
          Preguntas
        </Button>
        <Button
          className="btns"
          buttonStyle="btn--primary"
          buttonSize="btn--large"
          linkWeb="/"
        >
          Iniciar Sesion <i className="fa-solid fa-right-to-bracket" />
          {/* <FontAwesomeIcon icon="fa-solid fa-right-to-bracket" /> */}
        </Button>
      </div>
    </div>
  );
}

export default HeroSection;
